<div class="np-bar" data-testid="nav-plan-normal-container">
  <div class="np-bar-header">
    <!-- Always in the DOM and only hidden on the destination page: re-creating
         the button while the pager strip is still sliding back made iOS Safari
         paint the freshly inserted SVG at the wrong scale (cropped glyph) until
         the next repaint. -->
    <button class="np-icon-btn np-skip-btn" type="button"
      [class.np-skip-btn-hidden]="!skipAvailable"
      [ngClass]="{'inactive': activeComputer?.Type == 'cs' && cannotSkipMoreChargingStation}"
      [attr.aria-label]="languageService.languageJSON.Global_Skip"
      (click)="onSkipClick()"
      [attr.data-testid]="!skipAvailable ? null : (activeComputer?.Type == 'wp' ? 'nav-plan-normal-skip-waypoint-btn' : 'nav-plan-normal-skip-charging-btn')">
      <img class="skip-waypoint-icon"
        [src]="activeComputer?.Type == 'cs' ? 'assets/icons/default/ui/skip_charger_icon.svg' : 'assets/icons/default/ui/skip_waypoint_icon.svg'"
        alt="" />
    </button>

    <div class="np-battery" data-testid="nav-plan-normal-battery">
      <app-battery [batteryLevel]="estimatedBatteryLevel"></app-battery>
      <span class="np-battery-value">{{ estimatedBatteryLevel }}</span>
      <span class="np-battery-unit">%</span>
    </div>

    <button class="np-icon-btn np-close-btn" type="button"
      [attr.aria-label]="languageService.languageJSON.Global_Stop"
      (click)="onStopNavigation()"
      data-testid="nav-plan-normal-stop-btn"
      data-tutorial-target="stop-navigation">
      <img src="assets/icons/default/ui/cancel_icon.svg" alt="" />
    </button>
  </div>

  <div class="np-plan-rows-outer" [class.multi-page]="pageCount == 1">
    <div class="np-pager">
      <div class="np-pager-strip" #pagerStrip
      [class.is-swiping]="isSwiping()"
      [style.transform]="'translateX(' + (-activeIndex() * 100) + '%)'">
      @if (computersArray.length > 0) {
        @for (computerElement of computersArray; track computerElement.Type; let i = $index) {
          <app-navigation-plan-row class="np-page"
            [computer]="computerElement"
            (batteryReservedWarningClick)="onBatteryReservedWarning()"
            [attr.data-testid]="'nav-plan-row-item-' + i">
          </app-navigation-plan-row>
        }
      } @else {
        <app-navigation-plan-row class="np-page" data-testid="nav-plan-row-empty"></app-navigation-plan-row>
      }
      </div>
    </div>

    @if (pageCount > 1) {
      <div class="np-dots" data-testid="nav-plan-normal-dots">
        @for (computerElement of computersArray; track computerElement.Type; let i = $index) {
          <button class="np-dot" type="button"
            [class.active]="i == activeIndex()"
            (click)="goTo(i)"
            [attr.aria-label]="'' + (i + 1)">
          </button>
        }
      </div>
    }
  </div>
</div>
